import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService } from 'app/shared/services/cache.service';
import { Router } from '@angular/router';
import { AlertEnrollmentScope, EnrolledAlert, EnrollAlert, AlertScopesList, AlertType, AuthUser, AlertsList, UserAlertSearch, UserAlertList, UserAlertUpdate, UserAlertResponse, UserAlert, ContactVerification, AlertEnrollmentContact, AlertContact, AlertScopeCategoryTableData, EnrollAlertInq, AlertEnrollmentContactTableData } from 'app/shared/models/Alerts';
import { Observable, BehaviorSubject } from 'rxjs';
import { DateUtilityService } from 'app/shared/services/dateUtility.service';
import { UtilitiesService } from 'app/shared/services/utilities.service';

@Injectable()
export class AnnouncementsService {
	controller = 'api/auth/';
	verifyController = 'api/utilities/'
	private _firstTimeSetup:boolean;
	public firstTimeSetupObs:Observable<boolean>;
	public firstTimeSetupSubject: BehaviorSubject<boolean>;

	private _disabledTabs:Array<string>;
	public disabledTabsObs:Observable<Array<string>>;
	public disabledTabsSubject: BehaviorSubject<Array<string>>;

	private _refreshCategory: string;
	public rCategory:Observable<string>;
	public refreshCategorySubject: BehaviorSubject<string>;
	private _refreshDefaults: string;
	public rDefaults:Observable<string>;
	public refreshDefaultsSubject: BehaviorSubject<string>;

	public set refreshCategory(newValue: string) {
		this._refreshCategory = newValue;
		this.refreshCategorySubject.next(newValue);
	}
	public set refreshDefaults(newValue: string) {
		this._refreshDefaults = newValue;
		this.refreshDefaultsSubject.next(newValue);
	}
	public set FirstTimeSetup(newValue: boolean) {
		this._firstTimeSetup = newValue;
		this.firstTimeSetupSubject.next(newValue);
	}

	public set DisabledTabs(newValue: Array<string>) {
		this._disabledTabs = newValue;
		this.disabledTabsSubject.next(newValue);
	}

	//Stored here so I can force a refresh of it when they mess with alerts on the view page
	public bellAlerts: UserAlertResponse = new UserAlertResponse();
	public get NotificationCount(): number {
		let count = 0;
		if (this.bellAlerts.ual) {
			this.bellAlerts.ual.forEach(element => {
				if (!element.ViewedDTM) {
					count++;
				}
			});
		}
		return count;
	}
	constructor(
		private http: HttpClient,
		private cacheService: CacheService,
		private router: Router,
		private dateUtil: DateUtilityService,
		private utilSvc:UtilitiesService,
	) {
		this.refreshDefaultsSubject = new BehaviorSubject<string>('');
		this.rDefaults = this.refreshDefaultsSubject.asObservable();
		this.refreshCategorySubject = new BehaviorSubject<string>('');
		this.rCategory = this.refreshCategorySubject.asObservable();
		this.firstTimeSetupSubject = new BehaviorSubject<boolean>(true);
		this.firstTimeSetupObs = this.firstTimeSetupSubject.asObservable();
		this.disabledTabsSubject = new BehaviorSubject<Array<string>>(new Array<string>());
		this.disabledTabsObs = this.disabledTabsSubject.asObservable();
	}



	/**
	 *
	 * @param id
	 */
	public GetAlertScopeList(
		id?: number,
	): Observable<Array<AlertEnrollmentScope>> {
		let url = this.controller + 'GetAlertScopeList/'
		if (id) { url = url + id.toString(); }
		return this.http.get<Array<AlertEnrollmentScope>>(url);
	}

	/**
	 * Get All Alerts for the entity logged in
	 * @param
	 */
	public GetAlertsList<T>(inq:EnrollAlertInq): Promise<T> {
		let url = this.controller + 'GetAlertsList/';
		let reqParams = this.utilSvc.getHttpParams(inq);
		console.log(reqParams);
		return this.http.get<T>(url, {params:reqParams}).toPromise<T>();
	}

	//Alert Enrollment
	public DeleteAlertEnrollment(id: number) {
		const url = this.controller + "DeleteAlertEnrollment";
		let parms = new HttpParams().set('id', id.toString());
		return this.http.delete(url, { params: parms });
	}

	public GetAlertEnrollment(
		id?: number,
	): Promise<EnrollAlert> {
		let url = this.controller + 'GetAlertEnrollment/'
		if (id) { url = url + id.toString(); }
		return this.http.get<EnrollAlert>(url).toPromise<EnrollAlert>();
	}

	// public UpdateAlertEnrollment(type: EnrollAlert): Promise<any> {
	// 	const url = this.controller + 'UpdateAlertEnrollment';
	// 	return this.http.post(url, type).toPromise();
	// }

	public AlertEnrollmentSet(type: EnrollAlert): Promise<any> {
		const url = this.controller + 'AlertEnrollmentSet';
		return this.http.post(url, type).toPromise();
	}

	//Alert Scope Enrollment
	public DeleteAlertScopeEnrollment(id: number) {
		const url = this.controller + "DeleteAlertScopeEnrollment";
		let parms = new HttpParams().set('id', id.toString());
		return this.http.delete(url, { params: parms });
	}

	public GetAlertScopeEnrollment(
		id?: number,
	): Promise<AlertEnrollmentScope> {
		let url = this.controller + 'GetAlertScopeEnrollment/'
		if (id) { url = url + id.toString(); }
		return this.http.get<AlertEnrollmentScope>(url).toPromise<AlertEnrollmentScope>();
	}

	public UpdateAlertScopeEnrollment(type: AlertEnrollmentScope): Observable<any> {
		const url = this.controller + 'UpdateAlertScopeEnrollment';
		return this.http.post(url, type);
	}

	public InsertAlertScopeEnrollment(type: AlertEnrollmentScope): Observable<any> {
		const url = this.controller + 'InsertAlertScopeEnrollment';
		return this.http.post(url, type);
	}

	public GetAlertTypesList(
		id?: number,
	): Promise<Array<AlertEnrollmentScope>> {
		let url = this.controller + 'GetAlertTypesList/'
		if (id) { url = url + id.toString(); }
		return this.http.get<Array<AlertEnrollmentScope>>(url).toPromise<Array<AlertEnrollmentScope>>();
	}

	public GetAvailableScopesESP(
		atid?: number,
		pid?: number,
	): Observable<Array<AlertScopesList>> {
		let url = this.controller + 'GetScopesListESP/'
		if (atid) { url = url + atid.toString(); }
		if (pid) { url = url + "/" + pid.toString(); }
		return this.http.get<Array<AlertScopesList>>(url);
	}

	public GetAvailableAlertsESP(
		id?: number,
	): Promise<Array<AlertScopeCategoryTableData>> {
		let url = this.controller + 'GetAvailableAlertTypesESP/'
		if (id) { url = url + id.toString(); }
		return this.http.get<Array<AlertScopeCategoryTableData>>(url).toPromise<Array<AlertScopeCategoryTableData>>();
	}

	public GetAuthenticatedUser(
		id?: number,
	): Promise<AuthUser> {
		let url = this.controller + 'GetAuthenticatedUser/'
		if (id) { url = url + id.toString(); }
		return this.http.get<AuthUser>(url).toPromise<AuthUser>();
	}

	public UpdateAuthenticatedUser(type: AuthUser): Promise<any> {
		const url = this.controller + 'UpdateAuthenticatedUser';
		return this.http.post(url, type).toPromise();
	}



	public GetUserAlert(
		uaid?: number,
	): Promise<UserAlert> {
		let url = this.controller + 'GetUserAlert/'
		if (uaid) { url = url + uaid.toString(); }
		return this.http.get<UserAlert>(url).toPromise<UserAlert>();
	}

	public UserAlertList(inq: UserAlertSearch): Observable<UserAlertResponse> {
		const url = this.controller + 'UserAlertList';
		return this.http.post<UserAlertResponse>(url, inq);
	}

	public UpdateUserAlertList(alert: UserAlertUpdate): Observable<any> {
		const url = this.controller + 'UpdateUserAlertList';
		return this.http.post(url, alert);
	}
	public UserAlertSetViewed(userAlertID: number): Observable<any> {
		const url = this.controller + 'UserAlertSetViewed/' + userAlertID.toString();
		return this.http.post(url, alert);
	}


//Verification Routes
	public InsertEmailContactVerification(toPost:ContactVerification): Observable<any> {
		const url = this.verifyController + 'InsertEmailContactVerification';
		return this.http.post(url, toPost);
	}
	public InsertSMSContactVerification(toPost:ContactVerification): Observable<any> {
		const url = this.verifyController + 'InsertSMSContactVerification';
		return this.http.post(url, toPost);
	}
	public VerifyEmailContactVerification(toPost:ContactVerification): Promise<any> {
		const url = this.verifyController + 'VerifyEmailContactVerification';
		return this.http.post(url, toPost).toPromise();
	}
	public VerifySMSContactVerification(toPost:ContactVerification): Promise<any> {
		const url = this.verifyController + 'VerifySMSContactVerification';
		return this.http.post(url, toPost).toPromise();
	}


	//Alert enrollment contacts
	public GetAlertEnrollmentContactList(
		id?: number,
	): Observable<Array<AlertEnrollmentContact>> {
		let url = this.controller + 'GetAlertEnrollmentContactList/'
		if (id) { url = url + id.toString(); }
		return this.http.get<Array<AlertEnrollmentContact>>(url);
	}

	public UpdateAlertEnrollmentContact(type: AlertEnrollmentContact): Promise<any> {
		const url = this.controller + 'UpdateAlertEnrollmentContact';
		return this.http.post(url, type).toPromise();
	}

	public DeleteAlertEnrollmentContact(id: number) {
		let url = this.controller + "DeleteAlertEnrollmentContact/";
		if(id) url = url + id.toString();
		return this.http.delete(url);
	}


	//Generic Alert Contacts
	public GetAlertContactList(
		id?: number,
	): Observable<Array<AlertContact>> {
		let url = this.controller + 'GetAlertContactList/'
		if (id) { url = url + id.toString(); }
		return this.http.get<Array<AlertContact>>(url);
	}

	public InsertAlertContact(type: AlertContact): Promise<any> {
		const url = this.controller + 'InsertAlertContact';
		return this.http.post(url, type).toPromise();
	}

	public DeleteAlertContact(id: number) {
		const url = this.controller + "DeleteAlertContact/" + id.toString();
		return this.http.delete(url);
	}

	public populateBellAlerts() {
		let inq = new UserAlertSearch;
		inq.AlertTypeIDList = null;
		inq.EntityID = null;
		inq.EntityTypeID = 'SALESENTITY';
		inq.FromDTM = this.dateUtil.Get30DaysBack();
		inq.ToDTM = this.dateUtil.GetToday();
		inq.StartPage = 1;
		inq.ShowNew = true;
		inq.ShowViewed = true;
		inq.MaxRows = 0;
		inq.SortCol = 'CreatedDTM';
		inq.SortDir = 'DESC';
		this.UserAlertList(inq).toPromise().then(resp => {
			this.bellAlerts = resp;
		}).catch(err => {
			//shit
		});
	}
}
